<template>
  <div class="box">
    <div class="work">
      <!--路径 -->
      <div class="path">
        <img class="path_img" src="../../../../../assets/images/path.png"/>
        <div class="path_txt">运营管理系统 > 广告报表 > 快应用广告</div>
      </div>
      <!--查询条件-->
      <div class="condition">
        <div class="condi_line">
          <div class="condi_item_max">
            <div class="condi_item_label">日期范围:</div>
            <div class="condi_item_cnt_max">
              <el-date-picker
                      v-model="searchCondition.dateRange"
                      type="daterange"
                      value-format="yyyy-MM-dd"
                      value="yyyy-MM-dd"
                      range-separator="~"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期" 
                      style="width: 230px">
              </el-date-picker>
            </div>
          </div>
          <div class="condi_item">
            <div class="condi_item_label">投放平台：</div>
            <div class="condi_item_cnt">
              <el-select v-model="searchCondition.issuePlatform" filterable clearable @change="loadIssueFlows" placeholder="请选择投放平台">
                <el-option
                      v-for="item in issuePlatforms"
                      :key="item.issue_platform_tag"
                      :label="item.issue_platform_name"
                      :value="item.issue_platform_tag">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="condi_item">
            <div class="condi_item_label">投放流量：</div>
            <div class="condi_item_cnt">
              <el-select v-model="searchCondition.issueFlow" filterable clearable placeholder="请选择投放平台流量">
                <el-option
                      v-for="item in issueFlows"
                      :key="item.issue_flow_tag"
                      :label="item.issue_flow_name"
                      :value="item.issue_flow_tag">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="condi_item">
            <div class="condi_item_label">广告位:</div>
            <div class="condi_item_cnt">
              <el-input v-model="searchCondition.adSlotTag" clearable placeholder="请输入广告位标签"></el-input>
            </div>
          </div>
          <div class="condi_item">
            <div class="condi_item_label">资源位:</div>
            <div class="condi_item_cnt">
              <el-input v-model="searchCondition.adResourceUid" clearable placeholder="请输入资源位ID"></el-input>
            </div>
          </div>
        </div>
        <div class="condi_line">
          <div class="condi_item_max">
            <div class="condi_item_label">应用:</div>
            <div class="condi_item_cnt_max">
              <el-select v-model="searchCondition.appId" filterable  clearable  placeholder="请选择应用">
                <el-option
                        v-for="app in apps"
                        :key="parseInt(app.app_id)"
                        :label="'(' + app.app_id + ')' + app.app_name"
                        :value="parseInt(app.app_id)">
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="condi_item">
            <div class="condi_item_label">应用类型:</div>
            <div class="condi_item_cnt">
              <el-select v-model="searchCondition.appType" filterable  clearable  placeholder="请选择应用类型">
                <el-option
                        v-for="appType in Object.keys(appTypeMap)"
                        :key="parseInt(appType)"
                        :label="'(' + appType + ')' + appTypeMap[appType]"
                        :value="parseInt(appType)">
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="condi_item">
            <div class="condi_item_label">渠道:</div>
            <div class="condi_item_cnt">
              <el-select v-model="searchCondition.channelId" filterable clearable placeholder="请选择渠道">
                <el-option
                        v-for="item in channels"
                        :key="item.channel_id"
                        :label="'(' + item.channel_id + ')' + item.channel_name"
                        :value="item.channel_id">
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="condi_item">
            <div class="condi_item_label">渠道位置:</div>
            <div class="condi_item_cnt">
              <el-input v-model="searchCondition.channelSlotId" clearable placeholder="请输入渠道位置" />
            </div>
          </div>
        </div>

        <div class="condi_line">
          <div class="condi_item" style="width: 100%">
            <div class="condi_item_label">数据维度:</div>
            <div class="condi_item_cnt" style="width: 100%">
                <el-checkbox-group v-model="searchCondition.dimensions" label="数据维度" @change="onSearch">
                  <el-checkbox label="1" name="dimensions" :key="1" style="width:90px;">日期</el-checkbox>
                  <el-checkbox label="2" name="dimensions" :key="2" style="width:90px;">小时</el-checkbox>
                  <el-checkbox label="3" name="dimensions" :key="3" style="width:90px;">应用</el-checkbox>
                  <el-checkbox label="4" name="dimensions" :key="4" style="width:90px;">应用类型</el-checkbox>
                  <el-checkbox label="5" name="dimensions" :key="5" style="width:90px;">渠道</el-checkbox>
                  <el-checkbox label="6" name="dimensions" :key="6" style="width:90px;">渠道位置</el-checkbox>
                  <el-checkbox label="7" name="dimensions" :key="7" style="width:90px;">广告位</el-checkbox>
                  <el-checkbox label="8" name="dimensions" :key="8" style="width:90px;">资源位</el-checkbox>
                </el-checkbox-group>
            </div>
          </div>
        </div>

        <div class="condi_line">
          <div class="condi_item_max">
            <div class="condi_item_label"></div>
            <div class="condi_item_cnt_max">
              <el-button type="primary" @click="onSearch" style="width:110px;">查询</el-button>
            </div>
          </div>
        </div>
      </div>
      <!--数据列表-->
      <div class="datalist">
        <div class="dtlst_top">
          <div class="dtlst_title">快应用广告数据列表</div>
        </div>
        <div class="dtlst_table">
          <el-table
            :data="pageTable.tableData"
            stripe
          >
            <el-table-column prop="report_date" label="日期" width="120px" key="report_date" v-if="searchCondition.dimensions.indexOf('1')!=-1">
              <template slot-scope="scope">{{scope.row.report_date}}</template>
            </el-table-column>
            <el-table-column prop="report_hour" label="小时" width="80px" key="report_hour" v-if="searchCondition.dimensions.indexOf('2')!=-1">
              <template slot-scope="scope">{{scope.row.report_hour}}</template>
            </el-table-column>
            <el-table-column prop="app_id" label="应用" width="120px" key="app_id" v-if="searchCondition.dimensions.indexOf('3')!=-1">
              <template slot-scope="scope">({{scope.row.app_id}}){{apps.find(item => item.app_id==scope.row.app_id).app_name}}</template>
            </el-table-column>
            <el-table-column prop="app_type" label="应用类型" width="120px" key="app_type" v-if="searchCondition.dimensions.indexOf('4')!=-1">
              <template slot-scope="scope">({{scope.row.app_type}}){{appTypeMap[scope.row.app_type]}}</template>
            </el-table-column>
            <el-table-column prop="channel_id,channel_name" width="200px" label="渠道" key="channel_id,channel_name" v-if="searchCondition.dimensions.indexOf('5')!=-1">
              <template slot-scope="scope">({{scope.row.channel_id}}){{channelsMap[scope.row.channel_id]}}</template>
            </el-table-column>
            <el-table-column prop="channel_slot_id,channel_slot_name" width="100px" label="渠道位置" key="channel_slot_id,channel_slot_name" v-if="searchCondition.dimensions.indexOf('6')!=-1">
              <template slot-scope="scope">{{scope.row.channel_slot_id ? scope.row.channel_slot_id : ''}}</template>
            </el-table-column>
            <el-table-column prop="ad_slot_tag,ad_slot_name" label="广告位"  width="300px" key="ad_slot_tag,ad_slot_name" v-if="searchCondition.dimensions.indexOf('7')!=-1">
              <template slot-scope="scope">({{scope.row.ad_slot_tag}}){{scope.row.ad_slot_name}}</template>
            </el-table-column>
            <el-table-column prop="ad_resource_uid,ad_resource_name"  width="300px" label="资源位" key="ad_resource_uid,ad_resource_name" v-if="searchCondition.dimensions.indexOf('8')!=-1">
              <template slot-scope="scope">({{scope.row.ad_resource_uid}}){{scope.row.ad_resource_name}}</template>
            </el-table-column>

            <!--应用数据-->
            <template v-if="isShowAppColumn">
              <el-table-column prop="ad_cost" label="消耗" width="120px" align="right" key="ad_cost" v-if="searchCondition.dimensions.indexOf('2')==-1">
                <template slot-scope="scope">
                  {{scope.row.ad_cost ? parseFloat(scope.row.ad_cost * 1.0 / 1000000.0).toFixed(2) : '-'}}
                </template>
              </el-table-column>
              <el-table-column prop="union_pos_income" label="收入" width="120px" align="right" key="union_pos_income" >
                <template slot-scope="scope">
                  {{scope.row.lunion_pos_income ? parseFloat(scope.row.lunion_pos_income * 1.0 / 1000000.0 ).toFixed(2) : 0.00}}
                </template>
              </el-table-column>
              <el-table-column prop="app_uv" label="用户数" width="90px" key="app_uv"></el-table-column>
              
              <el-table-column prop="app_uv,ad_cost" label="单人成本" width="80px" align="right" key="app_uv,ad_cost" v-if="searchCondition.dimensions.indexOf('2')==-1">
                <template slot-scope="scope">
                  {{!scope.row.ad_cost || !scope.row.app_uv ? '-' : parseFloat(scope.row.ad_cost / (scope.row.app_uv * 1000000.0)).toFixed(4)}}
                </template>
              </el-table-column>
            
              <el-table-column prop="app_uv,union_pos_income" label="ARPU" width="80px" align="right" key="app_uv,union_pos_income" >
                <template slot-scope="scope">
                  {{!scope.row.app_uv || !scope.row.lunion_pos_income ? '-' : parseFloat(scope.row.lunion_pos_income / (scope.row.app_uv * 1000000.0)).toFixed(4)}}
                </template>
              </el-table-column>

              <el-table-column prop="roi1" label="ROI" width="60px" align="right" key="roi1" v-if="searchCondition.dimensions.indexOf('2')==-1">
                <template slot-scope="scope">
                  <el-tag style="width:50px;" type="danger" v-if="scope.row.ad_cost && (scope.row.lunion_pos_income / scope.row.ad_cost) < 1">
                    {{!scope.row.ad_cost ? '-' : parseFloat(scope.row.lunion_pos_income / scope.row.ad_cost).toFixed(2)}}
                  </el-tag>
                  <el-tag style="width:50px;" type="normal" v-if="!scope.row.ad_cost || scope.row.ad_cost && (scope.row.lunion_pos_income / scope.row.ad_cost) >= 1">
                    {{!scope.row.ad_cost ? '-' : parseFloat(scope.row.lunion_pos_income / scope.row.ad_cost).toFixed(2)}}
                  </el-tag>
                </template>
              </el-table-column>
            </template>
   

            <!--广告数据-->
            <template v-if="isShowAdColumn">
              <el-table-column prop="ad_click" width="110px" align="right" label="媒体点击成本" key="ad_cost,ad_click">
                <template slot-scope="scope">
                  {{scope.row.ad_click > 0 ? parseFloat(scope.row.ad_cost / 1000000.0 / scope.row.ad_click).toFixed(2) : '-'}}
                </template>
              </el-table-column>
              <el-table-column prop="ad_click" width="110px" align="right" label="媒体点击率" key="ad_click,ad_impression">
                <template slot-scope="scope">
                  {{scope.row.ad_impression > 0 ? parseFloat(scope.row.ad_click * 100.0 / scope.row.ad_impression).toFixed(2) + '%' : '-'}}
                </template>
              </el-table-column>
              <el-table-column prop="ad_effect_count" width="100px" align="right" label="媒体转化数" key="ad_effect_count">
                <template slot-scope="scope">
                  {{scope.row.ad_effect_count > 0 ? scope.row.ad_effect_count : '-'}}
                </template>
              </el-table-column>
              <el-table-column prop="ad_effect_count,ad_cost" width="110px" align="right" label="媒体转化成本" key="ad_cost,ad_effect_count">
                <template slot-scope="scope">
                  {{scope.row.ad_effect_count > 0 ? parseFloat(scope.row.ad_cost / 1000000.0 / scope.row.ad_effect_count).toFixed(2) : '-'}}
                </template>
              </el-table-column>
              <el-table-column prop="ad_effect_count,ad_click" width="100px" align="right" label="媒体转化率" key="ad_effect_count,ad_click">
                <template slot-scope="scope">
                  {{scope.row.ad_impression > 0 ? parseFloat(scope.row.ad_effect_count * 100.0 / scope.row.ad_click).toFixed(2) + '%' : '-'}}
                </template>
              </el-table-column>
            </template>
            

            <!--日志数-->
            <el-table-column prop="log_request" label="请求数" width="100px" key="log_request"></el-table-column>
            <el-table-column prop="log_request_uc" label="人均请求数" width="100px" key="log_request_uc">
              <template slot-scope="scope">{{(scope.row.log_request_uc==null || parseInt(scope.row.log_request_uc)==0) ? '-' : (parseFloat(scope.row.log_request) / parseFloat(scope.row.log_request_uc)).toFixed(4)}}</template>
            </el-table-column>
            <el-table-column prop="log_reqsucc" label="请求成功数" width="100px" key="log_reqsucc"></el-table-column>
            <el-table-column prop="log_bidsucc" label="竞胜数" width="100px" key="log_bidsucc"></el-table-column>
            <el-table-column prop="log_view" label="曝光数" width="90px" key="log_view"></el-table-column>
            <el-table-column prop="log_click" label="点击数" width="90px" key="log_click"></el-table-column>
            <el-table-column prop="log_close" label="关闭数" width="80px" key="log_close"></el-table-column>
            <el-table-column prop="log_bidsucc,log_request" label="竞胜率" width="100px" key="log_bidsucc,log_request">
              <template slot-scope="scope">{{(scope.row.log_request==null || parseInt(scope.row.log_request)==0) ? '-' : (parseFloat(scope.row.log_bidsucc) / parseFloat(scope.row.log_request) * 100).toFixed(2) + '%'}}</template>
            </el-table-column>
            <el-table-column prop="log_reqsucc,log_request" label="填充率" width="100px" key="log_reqsucc,log_request">
              <template slot-scope="scope">{{(scope.row.log_request==null || parseInt(scope.row.log_request)==0) ? '-' : (parseFloat(scope.row.log_reqsucc) / parseFloat(scope.row.log_request) * 100).toFixed(2) + '%'}}</template>
            </el-table-column>
            <el-table-column prop="log_reqsucc,log_request" label="请求成功曝光率" width="120px" key="log_reqsucc,log_request,log_view">
              <template slot-scope="scope">{{(scope.row.log_reqsucc==null || parseInt(scope.row.log_reqsucc)==0) ? '-' : (parseFloat(scope.row.log_view) / parseFloat(scope.row.log_reqsucc) * 100).toFixed(2) + '%'}}</template>
            </el-table-column>
            <el-table-column prop="log_bidsucc,log_view" label="竞胜曝光率" width="100px" key="log_bidsucc,log_view">
              <template slot-scope="scope">{{(scope.row.log_bidsucc==null || parseInt(scope.row.log_bidsucc)==0) ? '-' : (parseFloat(scope.row.log_view) / parseFloat(scope.row.log_bidsucc) * 100).toFixed(2) + '%'}}</template>
            </el-table-column>
            <el-table-column prop="log_view,log_click" label="点击率" width="100px" key="log_view,log_click">
              <template slot-scope="scope">{{(scope.row.log_view==null || parseInt(scope.row.log_view)==0) ? '-' : (parseFloat(scope.row.log_click) / parseFloat(scope.row.log_view) * 100).toFixed(2) + '%'}}</template>
            </el-table-column>

            <template v-if="isShowAppColumn">
              <el-table-column prop="app_uv,log_view" width="120px" aligsn="right" label="人均广告曝光数" key="app_uv,log_view">
                <template slot-scope="scope">
                  {{scope.row.app_uv > 0 ? parseFloat(scope.row.log_view * 1.0 / scope.row.app_uv).toFixed(2) : '-'}}
                </template>
              </el-table-column>
            </template>

            <template v-if="isShowAppColumn">
              <el-table-column prop="lunion_pos_income,log_view" width="100px" align="right" label="广告eCPM" key="lunion_pos_income,log_view">
                <template slot-scope="scope">
                  {{scope.row.log_view > 0 ? parseFloat(scope.row.lunion_pos_income / 1000.0 / scope.row.log_view).toFixed(2) : '-'}}
                </template>
              </el-table-column>
            </template>

            <template v-if="isShowAppColumn">
              <el-table-column prop="lunion_pos_income,log_view" width="100px" align="right" label="变现能力" key="lunion_pos_income,log_view">
                <template slot-scope="scope">
                  {{scope.row.log_view > 0 ? parseFloat((scope.row.lunion_pos_income / 1000.0 / scope.row.log_view) * (scope.row.log_view * 1.0 / scope.row.app_uv)).toFixed(2) : '-'}}
                </template>
              </el-table-column>
            </template>

            <template v-if="isShowAppColumn">
              <el-table-column prop="app_uv,log_click" width="120px" align="right" label="人均广告点击数" key="app_uv,log_click">
                <template slot-scope="scope">
                  {{scope.row.app_uv > 0 ? parseFloat(scope.row.log_click * 1.0 / scope.row.app_uv).toFixed(2) : '-'}}
                </template>
              </el-table-column>
            </template>

            <template v-if="isShowAdColumn">
              <el-table-column prop="app_ad_impression_uv,ad_click" width="100px" align="right" label="广告渗透率"  key="app_ad_impression_uv,ad_click">
                <template slot-scope="scope">
                  {{scope.row.ad_click > 0 ? parseFloat(scope.row.app_ad_impression_uv * 100.0 / scope.row.ad_click).toFixed(2) + '%' : '-'}}
                </template>
              </el-table-column>
              <el-table-column prop="app_ad_request_uv,ad_click" width="100px" align="right" label="请求渗透率" key="app_ad_request_uv,ad_click">
                <template slot-scope="scope">
                  {{scope.row.ad_click > 0 ? parseFloat(scope.row.app_ad_request_uv * 100.0 / scope.row.ad_click).toFixed(2) + '%' : '-'}}
                </template>
              </el-table-column>
              <el-table-column prop="app_landing_uv,ad_click" width="110px" align="right" label="落地页启动率" key="app_landing_uv,ad_click">
                <template slot-scope="scope">
                  {{scope.row.ad_click > 0 ? parseFloat(scope.row.app_landing_uv * 100.0 / scope.row.ad_click).toFixed(2) + '%' : '-'}}
                </template>
              </el-table-column>
              <el-table-column prop="app_uv,ad_click" width="100px" align="right" label="APP启动率" key="app_uv,ad_click">
                <template slot-scope="scope">
                  {{scope.row.ad_click > 0 ? parseFloat(scope.row.app_uv * 100.0 / scope.row.ad_click).toFixed(2) + '%' : '-'}}
                </template>
              </el-table-column>
            </template>
   

            <template v-if="isShowAppColumn">
              <el-table-column prop="app_effect_count,app_effect_total" label="效果(比例/回传/总数)" width="200px" align="right" key="app_effect_count,app_effect_total">
                <template slot-scope="scope">
                  {{scope.row.app_effect_total==0 ? '-' : parseFloat(scope.row.app_effect_count * 100.0 / scope.row.app_effect_total).toFixed(2) + '%'}}
                  /
                  {{scope.row.app_effect_count}}
                  /
                  {{scope.row.app_effect_total}}
                </template>
              </el-table-column>
            </template>

          </el-table>
          <div class="dtlst_pagination">
            <el-pagination
              background
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="pageTable.pageIndex"
              :page-size="pageTable.pageSize"
              :page-sizes="[100, 200, 500, 1000]" 
              :page-count="pageTable.pageCount"
              :total="pageTable.recordTotalCount"
              @current-change="changeCurrPage"
              @size-change="changePageSize"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  data() {
    return {
      // 操作员对象
      operator: null,
      
      // 分页表格
      pageTable: {
        pageIndex: 1,         // 当前页索引
        pageSize: 200,        // 本页显示数量
        pageCount: 1,         // 分页总数
        recordTotalCount: 0,  // 记录
        tableData: [],        // 应用列表数据
      },

      // 搜索的参数
      searchCondition: {
        dateRange: null,      // 日期范围
        issuePlatform: null,  // 投放平台
        issueFlow: null,      // 投放流量
        channelId: null,      // 渠道ID
        channelSlotId: null,  // 渠道位置ID
        adSlotTag: null,      // 广告位ID
        adResourceUid: null,  // 资源位ID
        appId: null,          // 应用ID
        appType: null,        // 应用类型
        dimensions: ["1","3","4"],          // 数据维度
        items: []                           // 数据项
      },

      adSlots:[],
      adResources: [],

      // 投放平台和流量列表
      issuePlatforms: [],
      issueFlows: [],

      apps: [],                 // 应用集合
      channels: [],             // 渠道
      channelsMap: {},          // 渠道映射
      
      // 应用类型
      appTypeMap: {
        61: "OPPO",
        62: "VIVO",
        63: "小米",
        65: "华为",
      },
    };
  },
  computed: {
    // 是否显示媒体数据
    isShowAdColumn() {
      return !this.searchCondition.dimensions.includes('2') && 
            !this.searchCondition.dimensions.includes('7') &&
            !this.searchCondition.dimensions.includes('8')
    },
    // 是否显示应用数据
    isShowAppColumn() {
      return !this.searchCondition.dimensions.includes('7') &&
            !this.searchCondition.dimensions.includes('8')
    },
  },
  created() {
    // 从缓存中恢复操作员对象
    let operatorSerial = localStorage.getItem('operator');
    if(operatorSerial==null || operatorSerial==undefined || operatorSerial=='') {
      // 返回登录页面
      this.$router.push('/');
      return;
    }
    this.operator = JSON.parse(operatorSerial);
    // 从缓存中恢复查询条件
    let sc = localStorage.getItem('sc.quickstat.adrpt');
    if(sc && sc.length>0) {
      let lsc = JSON.parse(sc);
      if(lsc.timestamp && (new Date().getTime() - lsc.timestamp) <= 30 * 60 * 1000) {
        this.searchCondition = lsc.data;
      } else {
        localStorage.removeItem('sc.quickstat.adrpt');
      }
    }
    // 加载初始化数据
    this.getInitDate();
    this.initApps();
    this.initChannels();
    this.initIssuePlatforms();
    // 获取数据
    // this.getStatLuckyData(1);
  },

  methods: {
    // 初始化应用
    async initApps(){
      // 清空当前集合数据
      this.apps = [];
      // 调用接口
      let res = await this.$api.apiCommonApps({businessLine: 'quickapp'});
      // 应用数据存进data
      this.apps = res.content;
    },

    async initChannels() {
      // 清空当前渠道
      this.channels = [];
      // 调用接口
      let res = await this.$api.apiCommonChannels();
      // 保存结果
      this.channels = res.content;
      // 保存到集合中
      this.channels.forEach((channel) => {
        this.channelsMap[channel.channel_id] = channel.channel_name;
      });
    },
    
    // 初始化发布平台
    async initIssuePlatforms() {
      // 清空当前渠道
      this.issuePlatforms = [];
      // 调用接口
      let res = await this.$api.apiCommonIssuePlatforms();
      // 保存结果
      this.issuePlatforms = res.content;
    },
    
    // 加载发布平台流量类型
    async loadIssueFlows() {
      // 清空当前流量类型
      this.searchCondition.issueFlow = null;
      this.issueFlows = [];
      // 调用接口
      let params = {};
      if(this.searchCondition.issuePlatform!=null && this.searchCondition.issuePlatform!='') {
        params['issuePlatformTag'] = this.searchCondition.issuePlatform;
      }
      let res = await this.$api.apiCommonIssueFlows(params);
      // 保存结果
      this.issueFlows = res.content;
    },
    
    async getStatLuckyData(mode) {
      // 如果日期为空，不能查询
      if(this.searchCondition.dateRange==null) {
        this.$message("报表查询必须选择日期范围","warning");
        return;
      }
      // 显示页面加载
      const loading = this.$loading({
        lock: true,//lock的修改符--默认是false
        text: 'Loading',//显示在加载图标下方的加载文案
        spinner: 'el-icon-loading',//自定义加载图标类名
        background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
        target: '.box'//遮罩区域
      });
      // 获取请求参数
      let params = new Object();
      params['pageIndex'] = this.pageTable.pageIndex;
      params['pageSize'] = this.pageTable.pageSize;
      params['operatorId'] = this.operator.operatorId;
      if(this.searchCondition.dateRange!=null && this.searchCondition.dateRange[0]!=null) {
        params['beginDate'] = moment(this.searchCondition.dateRange[0]).format('YYYY-MM-DD');
      }
      if(this.searchCondition.dateRange!=null && this.searchCondition.dateRange[1]!=null) {
        params['endDate'] = moment(this.searchCondition.dateRange[1]).format('YYYY-MM-DD');
      }
      if(this.searchCondition.issuePlatform!=null && this.searchCondition.issuePlatform!='') {
        params['issuePlatform'] = this.searchCondition.issuePlatform;
      }
      if(this.searchCondition.issueFlow!=null && this.searchCondition.issueFlow!='') {
        params['issueFlow'] = this.searchCondition.issueFlow;
      }
      if(this.searchCondition.channelId!=null && this.searchCondition.channelId!='') {
        params['channelId'] = this.searchCondition.channelId;
      }
      if(this.searchCondition.channelSlotId!=null && this.searchCondition.channelSlotId!='') {
        params['channelSlotId'] = this.searchCondition.channelSlotId;
      }
      if(this.searchCondition.adSlotTag!=null && this.searchCondition.adSlotTag!='') {
        params['adSlotTag'] = this.searchCondition.adSlotTag;
      }
      if(this.searchCondition.adResourceUid!=null && this.searchCondition.adResourceUid!='') {
        params['adResourceUid'] = this.searchCondition.adResourceUid;
      }
      if(this.searchCondition.appId!=null && this.searchCondition.appId!='') {
        params['appId'] = this.searchCondition.appId;
      }
      if(this.searchCondition.appType!=null && this.searchCondition.appType!='') {
        params['appType'] = this.searchCondition.appType;
      }
      if(this.searchCondition.dimensions!=null && this.searchCondition.dimensions.length>0) {
        params['dimensions'] = ',' + this.searchCondition.dimensions.join(',') + ',';
      }
      if(this.searchCondition.items!=null && this.searchCondition.items.length>0) {
        params['items'] = ',' + this.searchCondition.items.join(',') + ',';
      }
      // 调用接口
      if(mode==undefined || mode==1) {
        let res = await this.$api.apiLuckyStatAdrpt(params);
        if(res.result !== 1) {
          this.$message("加载快应用广告报表失败","warning");
          // 加载结束
          loading.close();
          return;
        }
        // 获取分页数据
        this.pageTable.pageIndex = res.content.pageIndex;
        this.pageTable.pageSize = res.content.pageSize;
        this.pageTable.pageCount = res.content.pageCount;
        this.pageTable.recordTotalCount = res.content.recordTotalCount;
        // 应用数据存进data
        this.pageTable.tableData = res.content.records;
      }
      // 加载结束
      loading.close();
    },
    
    // 搜索
    async onSearch(){
      // 保存查询条件
      localStorage.setItem('sc.quickstat.adrpt', JSON.stringify({
        'data': this.searchCondition,
        'timestamp': new Date().getTime()
      }));
      // 先清空原有数据
      this.tableData = [];
      // 查询应用
      this.getStatLuckyData(1);
    },
    
    // 变更当前页面
    async changeCurrPage(currPage) {
      this.pageTable.pageIndex = currPage;
      this.getStatLuckyData(1);
    },

    // 变更页面大小
    async changePageSize(pageSize) {
      this.pageTable.pageSize = pageSize;
      this.pageTable.pageIndex = 1;
      this.getStatLuckyData(1);
    },
    
    getInitDate(){
      if(this.searchCondition.dateRange!=null 
          && this.searchCondition.dateRange!=undefined 
          && this.searchCondition.dateRange.length>0) {
        return;
      }

      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth() + 1;
      let day = nowDate.getDate();

      let befDate = new Date();
      befDate=befDate.setDate(befDate.getDate() - 7);
      befDate=new Date(befDate)
      let byear = befDate.getFullYear();
      let bmonth = befDate.getMonth() + 1;
      let bday = befDate.getDate();

      // 默认日期赋值
      this.searchCondition.dateRange = [new Date(byear + ', ' + bmonth + ', ' + bday),new Date(year + ', ' + month + ', ' + day)];
    }
  },
};
</script>
<style lang='scss' scoped>
.box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-wrap: nowrap;
  align-items: center;
  overflow: auto;
}
.work {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  overflow: auto;
}
.path {
  margin: 10px 5px 0px 15px;
  padding: 0px;
  width: 100%;
  height: 20px;
  color: rgb(6, 6, 31);
  font-size: 1rem;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;
}
.path_img {
  margin-right:5px;
  height: 15px;
  width: 15px;
}
.path_txt {
  width: 100%;
  height: 20px;
  text-align: left;
}
.condition {
  margin: 10px 10px 10px 10px;
  padding: 5px 5px 5px 5px;
  width: 98%;
  height: auto;
  display: flex;
  flex-direction: row column;
  justify-content: flex-start;
  flex-wrap: wrap;
  background: #fff;
  border-radius: 9px;
  align-items: center;
}
.condi_line {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  flex-direction: row column;
  background: #fff;
  border-radius: 9px;
  align-items: center;
}
.condi_item {
  margin-left: 30px;
  width: 260px;
  height: 36px;
  display: flex;
  align-items: center;
}
.condi_item_max {
  margin-left: 30px;
  width: 330px;
  height: 36px;
  display: flex;
  align-items: center;
}
.condi_item_label {
  text-align: left;
  width: 100px;
  font-size: 16px;
}
.condi_item_cnt {
  width: 160px;
  font-size: 16px;
}
.condi_item_cnt_max {
  width: 230px;
  font-size: 16px;
}
.condi_item_cnt .el-input {
  width: 160px;
}
.condi_item_cnt_max .el-input {
  width: 230px;
}
.condi_item_cnt .el-select {
  width: 160px;
}
.condi_item_cnt_max .el-select {
  width: 230px;
}
.condi_item_cnt .el-button {
  width: 160px;
}
.condi_item_cnt_max .el-date-picker {
  width: 230px;
}
.datalist {
  margin: 0px 10px 10px 10px;
  padding: 5px 5px 5px 5px;
  width: 98%;
  height: auto;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  flex-direction: row;
  border-radius: 9px;
  overflow: auto;
  background: #fff;
}
.datalist .el-table {
  margin: 0 auto;
  width: 96%;
}
.dtlst_top {
  margin: 10px 10px 10px 15px;
  width: 96%;
  height: 25px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;
  align-items: center;
  background: #fff;
}
.dtlst_title {
  color: black;
  font-size: 1rem;
  font-weight: 500;
  height: 25px;
  text-align: left;
}
.dtlst_btn {
  height: 20px;
  width: calc(100% - 100px);
  text-align: right;
}
.dtlst_btn .el-button {
  margin: 0px 0px 0px 0px;
  padding: 0px 0px 0px 0px;
  color: white;
  background: #1890ff;
  height: 25px;
  width: 100px;
}
.dtlst_table {
  width: 98%;
  height: auto;
}
.dtlst_operation {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.dtlst_pagination {
  margin: 0 auto;
  width: 96%;
  height: 25px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
</style>